import React from 'react'

import { useParams } from 'react-router-dom'

import PageHeader from '../components/page-header/PageHeader';

import { category as categ } from '../api/tmdbApi';
import MovieGrid from '../components/movie-grid/MovieGrid';

const Catalog = () => {

    const { category } = useParams();

    console.log(category);
    return (
        <>
            <PageHeader>
                {category === categ.movie ? 'Movies' : 'TV Shows'}
            </PageHeader>
            <div className="container">
                <div className="section mb-3">
                    <MovieGrid category={category} />
                </div>
            </div>
        </>
    )
}

export default Catalog
